import React from 'react';
import styled from 'styled-components';
import { azure, midnight, white, spacer16, screenMdMin } from '@spotify-internal/encore-foundation';
import { Header } from './Header';
import { Hero } from './Hero';
import { Video } from './Video';
import { Features } from './Features';
import { ClaimBanner } from './ClaimBanner';
import { Testimonials } from './Testimonials';
import { Products } from './Products';
import { Faqs } from './Faq';
import { Footer } from './Footer';
import { GimletAcademy } from './GimletAcademy';

export function LandingPage() {
  return (
    <LandingPageContainer data-testid="landing-page--container">
      <Header />
      <Hero />
      <Video />
      <Features />
      <ClaimBanner />
      <Testimonials />
      <Products />
      <GimletAcademy />
      <Faqs />
      <Footer />
    </LandingPageContainer>
  );
}

const LandingPageContainer = styled.div`
  color: ${white};
  background-color: ${midnight};
  background-image: url('/images/landing_page/bg-01-hero.svg');
  background-position: top ${spacer16} right -500px;
  background-repeat: no-repeat;
  background-size: 1975px 660px;
  overflow: hidden;
  @media (min-width: ${screenMdMin}) {
    background-position: top center;
  }
`;
